var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Nuevo trabajador "+_vm._s(_vm.esteTrab)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }